import { render, staticRenderFns } from "./socialRelations.vue?vue&type=template&id=24b35ecc&scoped=true"
import script from "./socialRelations.vue?vue&type=script&lang=js"
export * from "./socialRelations.vue?vue&type=script&lang=js"
import style0 from "./socialRelations.vue?vue&type=style&index=0&id=24b35ecc&prod&scoped=true&lang=scss"
import style1 from "./socialRelations.vue?vue&type=style&index=1&id=24b35ecc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b35ecc",
  null
  
)

export default component.exports